export const GET_PORTALS_SUCCESS = 'GET_PORTALS_SUCCESS'
export const GET_TOPICS_SUCCESS = 'GET_TOPICS_SUCCESS'

export const GET_NAJCITANIJE_SUCCESS = 'GET_NAJCITANIJE_SUCCESS'
export const GET_NAJNOVIJE_SUCCESS = 'GET_NAJNOVIJE_SUCCESS'

export const SET_HOME_MOUNTED = 'SET_HOME_MOUNTED'

export const SET_SHARE_LINK = 'SET_SHARE_LINK'

export const SET_MY_TOPICS_TOKEN = 'SET_MY_TOPICS_TOKEN'
export const SET_MY_TOPICS = 'SET_MY_TOPICS'
